import React from "react";

import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  showDeletionModal: boolean;
  setDeletionModal: (show: boolean) => void;
  handleClose: () => void;
  handlerDeletion: () => void;
};

export const DeletionModal = ({
  showDeletionModal,
  setDeletionModal,
  handleClose,
  handlerDeletion,
}: Props) => {
  return (
    <Dialog
      open={showDeletionModal}
      onClose={() => {
        setDeletionModal(false);
      }}
    >
      <DialogTitle sx={{ color: "error.main", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        Löschen bestätigen
        <IconButton size="small" onClick={handleClose} aria-label="close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>Möchten Sie diese News wirklich löschen?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Nein
        </Button>
        <Button onClick={handlerDeletion} color="error" variant="contained">
          Ja
        </Button>
      </DialogActions>
    </Dialog>
  );
};
